import {defineAsyncComponent} from 'vue';

export default {
    'reveal-menu': defineAsyncComponent({
        loader: () => import ('./Components/RevealMenu/RevealMenu')
    }),
    'vue-image': defineAsyncComponent({
        loader: () => import ('./Components/Images/VueImage')
    }),
    'vue-bg-image': defineAsyncComponent({
        loader: () => import ('./Components/Images/VueBackgroundImage')
    }),
};